import React, { createContext, useCallback, useContext, useState } from "react";
import TaskCardModalContainer from "../../pages/TeamTasks/components/TaskCardModalContainer";
import { TeamTasksFeedbackProvider } from "../../pages/TeamTasks/components/TeamTasksFeedbackProvider";
import { resolveActivityTask } from "./openActivityTask";

const ActivityTaskModalContext = createContext(null);

export function ActivityTaskModalProvider({ leadId = null, children }) {
  const [card, setCard] = useState(null);

  const openTask = useCallback(
    async (ref) => {
      const resolved = await resolveActivityTask({
        cardId: ref?.cardId,
        title: ref?.title,
        leadId: ref?.leadId ?? leadId,
      });
      if (!resolved?.id) {
        const error = new Error("Tarefa não encontrada");
        error.code = "task_not_found";
        throw error;
      }
      setCard(resolved);
    },
    [leadId]
  );

  return (
    <ActivityTaskModalContext.Provider value={openTask}>
      <TeamTasksFeedbackProvider>
        {children}
        <TaskCardModalContainer
          open={Boolean(card)}
          card={card}
          board={null}
          boardId={card?.boardId || null}
          onClose={() => setCard(null)}
          extraCacheKeys={leadId ? [["teamBoardForLead", leadId]] : []}
          contextLeadId={leadId}
        />
      </TeamTasksFeedbackProvider>
    </ActivityTaskModalContext.Provider>
  );
}

export function useActivityTaskOpener() {
  return useContext(ActivityTaskModalContext);
}
